import { useSyncExternalStore } from 'react';

const DESKTOP = '(min-width: 1024px)';

const subscribers = new Map<string, (fn: () => void) => () => void>();

function subscribe(query: string) {
  const cached = subscribers.get(query);
  if (cached) return cached;
  const sub = (fn: () => void) => {
    const mql = window.matchMedia(query);
    mql.addEventListener('change', fn);
    return () => {
      mql.removeEventListener('change', fn);
    };
  };
  subscribers.set(query, sub);
  return sub;
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(subscribe(query), () => window.matchMedia(query).matches);
}

/** Desktop layout: sidebar, side panels, the full week planner. */
export const useDesktop = () => useMediaQuery(DESKTOP);

/** Fine pointer (mouse/trackpad): drag starts immediately instead of after a long press. */
export const useFinePointer = () => useMediaQuery('(pointer: fine)');
